export const ENVIRONMENT_VARIABLES = ['DEV','QA','PROD'];
